// modules/Splide.js
import Splide from '@splidejs/splide';

class SplideSlider {
  constructor() {
    // ensure DOM is ready before querying (optional but safe)
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.events());
    } else {
      this.events();
    }
  }

  events() {
    const sliders = document.querySelectorAll('.splide');
    if (!sliders.length) return;

    for (let i = 0; i < sliders.length; i++) {
      const el = sliders[i];

      // Skip if already initialized
      if (el.classList.contains('is-initialized')) continue;
      
      const splide = new Splide(el, {
        type: 'loop',
        perPage: el.dataset.perPage || 1,
        breakpoints: {
          1024: { perPage: el.dataset.perPageMedium || 1 },
          640:  { perPage: el.dataset.perPageSmall || 1 },
        },
        gap: '1rem',
        arrows: true,
        pagination: !(el.dataset.pagination === 'no'),
        autoplay: true,
        interval: 4000,
        pauseOnHover: true,
        pauseOnFocus: true,
        autoHeight: true,
        arrowPath: 'M22.1667 28.7917 ... 29.2917Z',
      });

      // THE PERFORMANCE HANDSHAKE
      // This listener waits for Splide to finish its setup.
      splide.on('mounted', () => {
        // Once the slider is functional, remove the "Loading" styles
        // This stops the CSS from "clashing" with the JS layout
        el.classList.remove('is-loading');
      });

      splide.mount();
    }
  }
}

export default new SplideSlider();